export default __webpack_public_path__ + "static/media/hero.fff0c53a.jpg";